module.exports = __webpack_public_path__ + "img/icon_vip.11ab5bde.png";